/* @index('./*.ts', f => `export * from '${f.path}';`) */
export * from './crud-service.provider';
export * from './crud.decorator';
export * from './crud.module';
export * from './crud.service';
/* @endindex */
